import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  position: absolute;
  z-index: 99;
  height: 100%;
`;

export const BottomSheetContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 768px;
  height: 100%;
  padding: 27px 16px;
  overflow: hidden;
  gap: 40px;
`;

export const SnapToMaxHeaderDiv = styled.div`
  position: absolute;
  width: 100%;
  height: 30px;
  inset: 0;
  border-radius: 16px;
  cursor: pointer;
`;

export const CheckMissionSection = styled.div`
  display: flex;
  position: absolute;
  bottom: 4%;
  left: 50%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, 0);
  font-size: 18px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  gap: 2px;
  ${({ theme }) => css`
    color: ${theme.content.content_light_1};
  `};
`;

export const bottomSheetStyle = css`
  [data-rsbs-overlay] {
    border: 1px solid #ccc;
    border-bottom: 0px;
    background-color: transparent;
    backdrop-filter: blur(25px);
  }

  [data-rsbs-header] {
    display: none;
  }
`;
